/**
 * 퀴즈 보기 설정 토글 버튼(안 푼 문제만 · 전체 보기 숨기기) 공용 outline 스타일 (JCG-2066).
 * 활성=파랑, 비활성=회색. 다크모드 페어 포함. RandomProblems / RandomizedProblems 가 공유한다.
 */
export function outlineToggleClass(active: boolean): string {
  return active
    ? "bg-blue-50 text-blue-700 border-blue-300 hover:bg-blue-100 dark:bg-blue-900 dark:text-blue-300 dark:border-blue-700 dark:hover:bg-blue-800"
    : "text-gray-600 border-gray-300 hover:bg-gray-100 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-800";
}
